import { render, staticRenderFns } from "./AmountInput.vue?vue&type=template&id=3f1829ea&"
import script from "./AmountInput.vue?vue&type=script&lang=ts&"
export * from "./AmountInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports